import { IconDocumentInfo } from '@maia/icons';
import { Button, showToast } from '@maia/ui';
import { downloadEncodedDocument } from '@maia/utils';
import { createFileRoute } from '@tanstack/react-router';
import { getInsurancesOptions } from '../../../../features/customer/insurances/queryOptions';
import { InsuranceTable } from '../../../../features/customer/insurances/table';
import { mapInitialFilters } from '../../../../utils/filter/utils';
import { validateSearch } from '../../../../utils/pagination';
import { useInsuranceOverview } from './../../../../features/customer/insurance-overview/queryOptions';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/insurances',
)({
  loaderDeps: ({ search }) => search,
  loader: async ({
    context: { queryClient },
    deps: search,
    params: { guid },
  }) => {
    const searchWithDefaultFilters = search.filter
      ? search
      : { ...search, filter: ['status,active'] };
    return await queryClient.ensureQueryData(
      getInsurancesOptions(guid, mapInitialFilters(searchWithDefaultFilters)),
    );
  },
  validateSearch: validateSearch,
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  const params = Route.useParams();
  const { mutateAsync, isPending } = useInsuranceOverview(
    params.guid,
    () => {
      showToast({
        intent: 'success',
        title: 'Verzekeringsoverzicht gedownload',
        config: { position: 'top-right' },
      });
    },
    () => {
      showToast({
        intent: 'error',
        title: 'Er ging iets mis',
        description:
          'We konden niet het verzekeringsoverzicht ophalen. Probeer het later opnieuw',
        config: { position: 'top-right' },
      });
    },
  );

  return (
    <>
      <div className="col-span-full flex items-center justify-between">
        <InsuranceTable insurances={data} />
      </div>

      <div className="col-span-full flex justify-end">
        <Button
          intent="secondary"
          size="small"
          iconLeft={IconDocumentInfo}
          onPress={() => mutateAsync().then(downloadEncodedDocument)}
          isLoading={isPending}
          isDisabled={isPending}
        >
          Verzekeringsoverzicht
        </Button>
      </div>
    </>
  );
}
